import React from 'react';
import cx from 'classnames';

const WidthController = ({ children, className, classes }) => (
  <div className={cx(classes.root, className)}>{children}</div>
);

export default WidthController;
